module.exports = __webpack_public_path__ + "static/media/clearwater_sunset.1220bd16.jpg";